import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var generateStyle = function generateStyle(componentTheme, props) {
  var msMaxWidth = 'max-width: 25rem';
  var mq = "@media only screen and (".concat(msMaxWidth, ")");
  return {
    metricsContainer: _defineProperty({
      paddingBottom: componentTheme.metricsPadding,
      display: 'flex',
      justifyContent: 'flex-start',
      columnGap: '26px',
      rowGap: '8px'
    }, mq, {
      flexWrap: 'wrap'
    }),
    reportCard: _objectSpread(_defineProperty({
      width: componentTheme.cardWidth,
      padding: componentTheme.cardPadding,
      margin: componentTheme.cardMargin,
      display: 'inline-flex',
      flexDirection: 'column'
    }, mq, {
      width: 'initial',
      maxWidth: componentTheme.cardWidth
    }), !props.quizAnalysis && !props.analysisError && _defineProperty({
      height: componentTheme.cardHeight
    }, mq, {
      height: 'initial'
    })),
    emptyCardBodyContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      alignSelf: 'flex-end',
      height: '100%'
    },
    dateContainer: {
      maxWidth: '160px',
      paddingRight: '10px'
    },
    quizAnalysisSummary: {
      borderBottom: "1px solid ".concat(componentTheme.quizSummaryBorderBottomColor),
      paddingBottom: '15px',
      marginBottom: '15px'
    },
    titleContainer: {
      paddingBottom: '15px'
    }
  };
};
export default generateStyle;